import React, { Component } from 'react';
import ReviewAndSubmitPres from '../Presentation/ReviewAndSubmitPres';
import { getReviewSummaryHtml } from 'src/services/questionnaire.service.js';
import { withSnackbar } from 'notistack';
import { connect } from 'react-redux';
import html2pdf from 'html2pdf.js';
import moment from 'moment';
import { resetQuestionnaire } from 'src/new-ui/features/CaseDataCollect/state/caseDataCollectAction';

class ReviewAndSubmitContainer extends Component {
  state = {
    htmlcont: null,
  };
  componentDidMount() {
    const entityId = this.props.location.pathname && this.props.location.pathname.split('/')[3];
    this.setState({
      htmlcont: getReviewSummaryHtml(entityId).htmlContent,
    });
  }
  componentWillUnmount() {
    if (typeof this.props.resetQuestionnaire === 'function') {
      this.props.resetQuestionnaire();
    }
  }

  onDownloadPDF = () => {
    const fileName =
      this.props.casedetails.employeeName +
      '_' +
      this.props.casedetails.serviceCountry +
      '_' +
      this.props.casedetails.caseTicketId +
      '_' +
      moment(new Date()).format('DDMMMYYYY') +
      '.pdf';
    let pages = [];
    pages.push(document.getElementById('container'));

    let options = {
      margin: 10,
      filename: fileName,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: '', orientation: 'landscape', compressPDF: true },
      pagebreak: { mode: 'avoid-all' },
    };
    let doc = html2pdf()
      .set(options)
      .from(pages[0])
      .toPdf();
    doc.save();
  };

  render() {
    return (
      <React.Fragment>
        <ReviewAndSubmitPres htmlcont={this.state.htmlcont} onDownloadPDF={this.onDownloadPDF} {...this.props} {...this.state} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  casedetails: state.caseDatacollectMenu.caseHeaderDetails,
});

const mapDispatchToProps = {
  resetQuestionnaire,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ReviewAndSubmitContainer));
